module.exports = __webpack_public_path__ + "static/antd-space-custom-spacing-b47f3b15261783a2cbc485411ee04bd4.gif";